import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Row } from "./row";
import { LoaderRow } from "./loader/row";
import {
  computeExpectedPeriods,
  formatPeriodLabel,
  groupPeriodsByMonth,
} from "./utils";
import { Props } from "./types";
import styles from "./styles.scss";

const FIRST_LOAD_ROWS = 8;
const LOADING_MORE_ROWS = 3;

function Table(props: Props) {
  const { t, i18n } = useTranslation();
  const periods =
    props.resources[0]?.periods ||
    computeExpectedPeriods(props.from, props.to, props.granularity);
  const isWeekly = props.granularity === "WEEK";
  const monthGroups = isWeekly
    ? groupPeriodsByMonth(periods, i18n.language)
    : [];

  return (
    <div className={styles.tableWrapper}>
      <div
        className={styles.table}
        style={{
          gridTemplateColumns: `28rem repeat(${periods.length}, 10rem)`,
        }}
      >
        {isWeekly && (
          <React.Fragment>
            <div className={styles.monthCornerCell} />
            {monthGroups.map((group, index) => (
              <div
                key={index}
                className={styles.monthCell}
                style={{ gridColumn: `span ${group.span}` }}
              >
                {group.label}
              </div>
            ))}
          </React.Fragment>
        )}
        <div
          className={classNames(styles.resourceHeaderCell, {
            [styles.withMonthRow]: isWeekly,
          })}
        >
          {t("capacityPage.table.resource")}
        </div>
        {periods.map((period, index) => (
          <div
            key={index}
            className={classNames(styles.headerCell, {
              [styles.withMonthRow]: isWeekly,
            })}
          >
            {formatPeriodLabel(period, props.granularity, i18n.language)}
          </div>
        ))}
        {props.resources.map((resource) => (
          <Row
            key={resource.uuid}
            resource={resource}
            granularity={props.granularity}
            locale={i18n.language}
            canEdit={props.canEdit}
          />
        ))}
        {props.isLoadingMore &&
          Array.from(
            {
              length:
                props.resources.length === 0
                  ? FIRST_LOAD_ROWS
                  : LOADING_MORE_ROWS,
            },
            (_, index) => <LoaderRow key={index} columns={periods.length} />,
          )}
      </div>
    </div>
  );
}

export { Table };
